var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSesior(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 213.739,
    height: 218.784,
    viewBox: "0 0 213.739 218.784",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13416",
    "data-name": "Group 13416",
    transform: "translate(76.429) rotate(30)",
    opacity: 0.04
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13918",
    "data-name": "Path 13918",
    d: "M622.642,667.006,544.208,782.842a32.375,32.375,0,1,0-5.224,22.788l81.824-120.844C624.535,679.288,625.429,668.893,622.642,667.006ZM512.13,811.415a23.947,23.947,0,1,1,19.855-10.523A23.816,23.816,0,0,1,512.13,811.415Z",
    transform: "translate(-479.748 -667.006)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13919",
    "data-name": "Path 13919",
    d: "M626.889,769.3a32.381,32.381,0,0,0-58.872,13.54L489.578,667.006c-2.787,1.887-1.887,12.282,1.834,17.78L573.241,805.63a32.381,32.381,0,0,0,26.848,14.234h0a32.395,32.395,0,0,0,26.8-50.562Zm-3.307,22.692a23.961,23.961,0,0,1-23.488,19.421h0a23.944,23.944,0,1,1,23.492-19.421Z",
    transform: "translate(-473.919 -667.006)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7512",
    "data-name": "Group 7512",
    transform: "translate(139.551 138.206)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13920",
    "data-name": "Path 13920",
    d: "M587.681,763.964a39.908,39.908,0,0,1-24.78-8.656,4.225,4.225,0,1,1,5.264-6.611,31.016,31.016,0,0,0,19.516,6.815,4.226,4.226,0,0,1,0,8.452Z",
    transform: "translate(-561.306 -747.777)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7513",
    "data-name": "Group 7513",
    transform: "translate(40.682)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13921",
    "data-name": "Path 13921",
    d: "M579.108,667.006l-36.979,54.607-36.976-54.607c-2.767,1.874-1.9,12.135,1.762,17.66l35.2,52.025.01-.021.012.021,35.205-52.025C581,679.141,581.875,668.88,579.108,667.006Z",
    transform: "translate(-503.524 -667.006)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7514",
    "data-name": "Group 7514",
    transform: "translate(65.112)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13922",
    "data-name": "Path 13922",
    d: "M544.523,667.006l-12.546,18.528-12.546-18.528c-2.784,1.887-1.889,12.262,1.824,17.766l10.712,15.85.01-.019.012.019,10.711-15.85C546.413,679.268,547.31,668.893,544.523,667.006Z",
    transform: "translate(-517.801 -667.006)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSesior);
export default __webpack_public_path__ + "static/media/sesior.125aa1d54988e4f006ad315975ab1dec.svg";
export { ForwardRef as ReactComponent };